import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
} from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NzModalService } from 'ng-zorro-antd/modal';
import { RouterPath } from '../../shared/models';
import { ContactModalComponent } from '../../shared/modals/contact-modal/contact-modal.component';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements AfterViewInit {
    @ViewChild('heroVideo') heroVideo!: ElementRef<HTMLVideoElement>;
    offices = {
        vietnam: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6314045.916015201!2d102.144!3d16.0544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3141a13d2b61fdd3%3A0x40223bc2c1c7f20!2zVmnhu4duIE5hbQ!5e0!3m2!1svi!2s!4v1729573000000!5m2!1svi!2s',
        hanoi: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.8927784310637!2d105.78815097535555!3d21.019895086063013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ab3c9b4a18d7%3A0x4e13e2b3b7a5736f!2s219%20P.%20Trung%20K%C3%ADnh%2C%20Trung%20Ho%C3%A0%2C%20C%E1%BA%A7u%20Gi%E1%BA%A5y%2C%20H%C3%A0%20N%E1%BB%99i%20100000!5e0!3m2!1svi!2s!4v1730100000000!5m2!1svi!2s', // link Hà Nội
        hcm: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.7860990341285!2d106.68709967529662!3d10.803972989342207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317528c89a2f3bff%3A0xeeb15f14c951f56!2s24C%20Phan%20%C4%90%C4%83ng%20L%C6%B0u%2C%20Ph%C6%B0%E1%BB%9Dng%207%2C%20B%C3%ACnh%20Th%E1%BA%A1nh%2C%20Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh!5e0!3m2!1svi!2s!4v1730101000000!5m2!1svi!2s', // link HCM
    };
    dropdownOpen = false;
    selectedOffice = 'vietnam';
    showScrollTop = false;

    protected readonly RouterPath = RouterPath;

    constructor(
        private modalService: NzModalService,
        private el: ElementRef,
        private meta: Meta,
    ) {
        const desc = "DataCore is Vietnam's trusted financial data platform — market data, analytics tools, and real-time validation for research, corporate, and government teams.";
        this.meta.updateTag({ name: 'description', content: desc });
        this.meta.updateTag({ property: 'og:description', content: desc });
        this.meta.updateTag({ name: 'twitter:description', content: desc });
    }

    // Sự kiện scroll trang
    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.showScrollTop = window.scrollY > 200;
    }

    ngAfterViewInit(): void {
        window.scrollTo(0, 0);
        // Feature
        $(this.el?.nativeElement)?.find('.mobile-features')?.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            dots: false,
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '50px', // chỉ hiển thị thêm nửa bên phải
                    },
                },
                {
                    breakpoint: 99999, // mọi màn hình lớn hơn 767
                    settings: 'unslick', // hủy slick
                },
            ],
        });

        const video = this.heroVideo.nativeElement;

        // cố gắng autoplay sau khi load DOM
        const playPromise = video.play();

        if (playPromise !== undefined) {
            playPromise
                .then(() => {
                    // ✅ autoplay thành công
                    console.log('Video autoplayed successfully.');
                })
                .catch((error) => {
                    // ❌ fallback nếu bị chặn autoplay (hiếm khi xảy ra nếu muted)
                    console.warn('Autoplay prevented:', error);
                    video.muted = true;
                    video.play().catch(() => {});
                });
        }
    }

    // Scroll lên đầu trang
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    openContactModal() {
        this.modalService.create({
            nzTitle: 'Contact DataCore',
            nzContent: ContactModalComponent,
            nzFooter: null,
            nzStyle: { top: '50px', width: '600px' },
            nzMaskClosable: false,
        });
    }

    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }
}
